document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.metafield-accordion');
  const contents = document.querySelectorAll('.metafield-content');
  const contentWrapper = document.querySelector(".metafield-content-wrapper");
  const accordionWrapper = document.querySelector(".metafield-accordion-wrapper");
  const accordions = document.querySelectorAll(".custom-accordion");
  const footerLinks = document.querySelectorAll('.footer__links ul li');
  const arrowIcon = document.querySelector(".navigate svg");
  const currentPageTitle = document.querySelector(".current-page");
  const shopUrlElement = document.querySelector("[data-shop-url]");
  const newPageTemplateUrl = `${shopUrlElement.getAttribute("data-shop-url")}/pages/faq?view=new`;

  // Initialize tabs and accordions on page load
  initializeTabs();
  initializeAccordions();
  initializeFooterLinks();
  handlePageUrl();

  function initializeTabs() {
      if (tabs.length > 0) {
          tabs.forEach((tab, index) => {
              tab.addEventListener('click', () => {
                  hideAllContents();
                  if (contents.length > 0) {
                      contents[index].style.display = "block";
                  }
                  updateTabTransform(tab);
                  updateBreadcrumb(tab);
                  scrollToTop();
                  contentWrapper.classList.add('active');
                  accordionWrapper.classList.remove('active');
              });
          });
      }
      showFirstTabContent();
  }
  
  // Scroll to the top of the page
  function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
  }
  
  // Displays the first tab content on page load.
  function showFirstTabContent() {
      hideAllContents();
      if (tabs.length > 0) {
          updateTabTransform(tabs[0]);
          contents[0].style.display = "block";
      }
  }

  // Hides all content elements.
  function hideAllContents() {
      contents.forEach(content => content.style.display = "none");
  }

  // Updates the transform style of the selected tab.
  function updateTabTransform(tab) {
      resetTabTransforms();
      tab.querySelector('p').style.transform = "translateX(15px)";
  }

  // Resets the transform style of all tabs to their original position.
  function resetTabTransforms() {
      tabs.forEach(tab => tab.querySelector('p').style.transform = "translateX(0)");
  }

  // Initializes accordion functionality.
  function initializeAccordions() {
      if (accordions.length > 0) {
          accordions.forEach(accordion => {
              accordion.addEventListener("click", function() {
                  toggleAccordion(this);
              });
          });
      }
  }

  // Toggles the accordion state.
  function toggleAccordion(accordion) {
      // Close all other accordion panels
      accordions.forEach(item => {
          if (item !== accordion) {
              item.classList.remove("active");
              const panel = item.nextElementSibling;
              panel.style.maxHeight = null;
              panel.style.paddingBlock = "0";
          }
      });

      // Toggle the clicked accordion
      accordion.classList.toggle("active");
      const panel = accordion.nextElementSibling;
      if (accordion.classList.contains("active")) {
          panel.style.maxHeight = `${panel.scrollHeight}px`;
          panel.style.paddingBlock = "0";
      } else {
          panel.style.maxHeight = null;
          panel.style.paddingBlock = "0";
      }
  }

  // Initializes footer link handling.
  function initializeFooterLinks() {
      if (footerLinks.length > 0) {
          footerLinks.forEach(link => {
              const handle = link.getAttribute("data-url-handle");
              if (window.location.href.trim().toLowerCase().includes(handle)) {
                  tabs.forEach((tab, index) => {
                      if (tab.querySelector('p').textContent.toLowerCase().includes(handle)) {
                          hideAllContents();
                          contents[index].style.display = "block";
                          updateTabTransform(tab);
                          updateBreadcrumb(tab);
                          contentWrapper.classList.add('active');
                      }
                  });
              }
          });
      }
  }

  // Updates the breadcrumb to show the current page title.
  function updateBreadcrumb(tab) {
      const title = tab.querySelector('p').textContent.toLowerCase();
      currentPageTitle.style.display = "inline";
      arrowIcon.style.display = "inline";
      currentPageTitle.textContent = title;
  }

  // Handles URL-specific logic on page load.
  function handlePageUrl() {
      if (window.location.href === newPageTemplateUrl) {
          arrowIcon.style.display = "none";
          currentPageTitle.style.display = "none";
          accordionWrapper.classList.add('active');
          contentWrapper.classList.remove('active');
          resetTabTransforms(); // Clear transform positions
      }
  }
});
